<template>
  <b-card
      no-body
      class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-0">
        {{ $t('Subscription Status') }}
      </h5>
      <feather-icon 
        icon="CalendarIcon"
        size="20"
        class="text-primary"
      />
    </b-card-header>

    <b-card-body>
      <p class="text-muted mb-3">
        {{ $t('View complete subscription details and manage your devices') }}
      </p>
      
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
          @click="goToSubscriptionStatus"
      >
        <feather-icon 
          icon="EyeIcon"
          size="16"
          class="mr-50"
        />
        {{ $t('View Subscription Status') }}
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
    FeatherIcon,
  },
  methods: {
    goToSubscriptionStatus() {
      this.$router.push({ name: 'subscriptionStatus' })
    },
  },
}
</script>

<style>

</style>
